import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=677e2f1c&"
import script from "./UserMenu.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserMenu.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports